import { create } from 'zustand';

export interface DispatchTask {
    id: string;
    vehicleName: string;
    taskType: 'NORMAL' | 'ORDER' | 'CYCLE';
    status: 'PENDING' | 'RUNNING' | 'COMPLETED' | 'CANCELLED' | 'FAILED';
    stops: string[];
    currentStop?: string;
    progress: number;
    createdAt: string;
    updatedAt: string;
}

export interface DispatchFormData {
    vehicleName: string;
    taskType: 'NORMAL' | 'ORDER' | 'CYCLE';
    stops: Array<{
        stopCode: string;
        stopOverTime?: number;
    }>;
    cycleType?: number;
}

export interface DispatchState {
    // 当前任务列表
    tasks: DispatchTask[];
    // 表单数据
    formData: DispatchFormData | null;
    // 是否显示表单
    formVisible: boolean;
    // 是否正在提交
    submitting: boolean;
    // 是否正在加载
    loading: boolean;

    // Actions
    setTasks: (tasks: DispatchTask[]) => void;
    addTask: (task: DispatchTask) => void;
    updateTask: (id: string, updates: Partial<DispatchTask>) => void;
    removeTask: (id: string) => void;
    setFormData: (data: DispatchFormData | null) => void;
    setFormVisible: (visible: boolean) => void;
    setSubmitting: (submitting: boolean) => void;
    setLoading: (loading: boolean) => void;
    resetForm: () => void;
}

const initialFormData: DispatchFormData = {
    vehicleName: '',
    taskType: 'NORMAL',
    stops: [],
};

export const useDispatchStore = create<DispatchState>((set) => ({
    tasks: [],
    formData: null,
    formVisible: false,
    submitting: false,
    loading: false,

    setTasks: (tasks) => set({ tasks }),

    addTask: (task) =>
        set((state) => ({
            tasks: [task, ...state.tasks],
        })),

    updateTask: (id, updates) =>
        set((state) => ({
            tasks: state.tasks.map((task) =>
                task.id === id ? { ...task, ...updates } : task
            ),
        })),

    removeTask: (id) =>
        set((state) => ({
            tasks: state.tasks.filter((task) => task.id !== id),
        })),

    setFormData: (data) => set({ formData: data }),

    setFormVisible: (visible) =>
        set({
            formVisible: visible,
            formData: visible ? initialFormData : null,
        }),

    setSubmitting: (submitting) => set({ submitting }),

    setLoading: (loading) => set({ loading }),

    resetForm: () =>
        set({
            formData: null,
            formVisible: false,
            submitting: false,
        }),
}));
